import {
  FavouriteBrand,
  CountriesBrandsFilter,
  CountryBrands
} from '../types';

import { locatorServiceAPI } from 'shared/services';

export const brandsAPI = {
  getFavouriteBrands: () => locatorServiceAPI.get<{ favouriteBrands: FavouriteBrand[] }>('favourite/brands'),
  addFavouriteBrands: (billingIds: FavouriteBrand['billingId'][]) => locatorServiceAPI.put<{
    favouriteBrands: Pick<FavouriteBrand, 'billingId' | 'logo' | 'title'>[]
  }>('favourite/brands', billingIds),
  deleteFavouriteBrands: (billingIds: FavouriteBrand['billingId'][]) => locatorServiceAPI.delete('favourite/brands', { data: billingIds }),
  getCountriesBrands: (filter: CountriesBrandsFilter) => locatorServiceAPI.post<{
    countries: CountryBrands[];
  }>('countries/brands', filter)
};
